module.exports = __webpack_public_path__ + "img/red.c535b0bb.png";